// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FreeGiftBuoy_wrapper__1mLaz","image":"FreeGiftBuoy_image__2_RAM","close":"FreeGiftBuoy_close__n6nWp"};